import { apiSlice } from "../../app/api/apiSlice";

export const standardConditionRemoveConditionApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			standardConditionRemoveCondition: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/remove_standard_conditions/${credentials?.loanGuid}/conditions/${credentials?.conditionType}/`,
					method: "PATCH",
					body: credentials?.data ?? [{ id: credentials?.conditionId }],
				}),
			}),
		}),
	});

export const { useStandardConditionRemoveConditionMutation } =
	standardConditionRemoveConditionApiSlice;
